import React from "react";
import BaseModal from "../../../../components/ui/BaseModal";
import VerifyIdentity from "../../../CompleteYourProfile/Forms/VerifyIdentity";
import SearchLocation from "../../../../components/SearchLocation/SearchLocation";

const AddEditVerifyIdentityModal = ({
  open,
  close,
  identityDocuments,
  refetchMe,
  personalAddress,
}) => {
  return (
    <BaseModal
      className="-top-[200px] overflow-auto"
      open={open}
      close={close}
      style={{ width: "1060px" }}
    >
      <div className="py-4 px-8">
        <div className="flex justify-between items-center border-b-2 pb-1">
          <h5 className="text-dark font-normal ">Verify your Identity</h5>
        </div>
      </div>

      <div className="px-4 pb-4">
        <VerifyIdentity
          identityDocuments={identityDocuments}
          mode="USER_SETTINGS"
          refetchMe={refetchMe}
          address={personalAddress}
          onClose={close}
        />
      </div>
    </BaseModal>
  );
};

export default AddEditVerifyIdentityModal;
